import { makeStyles } from "@material-ui/core/styles";

export const AuctionListStyles = makeStyles(theme => ({
  tile: {
    height: "100% !important"
  }
}));
